import { StageDefinition } from './StageDefinition';

export const stage07: StageDefinition = {
    platforms: [
        [0, 0],
        [11.612903225806452, 0],
        [23.225806451612904, 0],
        [34.83870967741936, 0],
        [185.80645161290326, 0],
        [325.1612903225808, 0],
        [336.77419354838725, 0],
        [348.3870967741937, 0],
        [196.36363636363643, 2],
        [286.3636363636365, 2],
        [208.42105263157902, 4],
        [221.05263157894746, 4],
        [233.6842105263159, 4],
        [246.31578947368433, 4],
    ],
    traps: [
        [46.45161290322581, 0],
        [58.064516129032256, 0],
        [313.5483870967743, 0],
        [88.42105263157895, 4],
        [94.73684210526315, 4],
        [101.05263157894736, 4],
        [107.36842105263156, 4],
    ],
    stars: [
        [144, 1],
        [218, 0],
        [285, 4],
    ],
};
